// import React, { useState, useEffect, useRef } from "react";
// import { Link, useNavigate } from 'react-router-dom';
// import { FaUsers } from 'react-icons/fa';
// import IconButton from '@mui/material/IconButton';
// import Typography from '@mui/material/Typography';
// import Box from '@mui/material/Box';
// import Menu from '@mui/material/Menu';
// import { Avatar } from "@mui/material";
// import Tooltip from '@mui/material/Tooltip';
// import MenuItem from '@mui/material/MenuItem';
// import { FaUserCircle } from 'react-icons/fa';
// import verifyToken from '../HelperFx/verifyJwt.js';
// import Logo from '../images/logo/logo.png';
// import { Buffer } from 'buffer';
// import axios from 'axios';

// const settings = ['Profile', 'Change Password', 'Logout'];

// const REACT_EXPRESS = process.env.REACT_APP_EXPRESS_SERVER;
// // const REACT_UNAME = process.env.REACT_APP_API_USERNAME;
// // const REACT_PWD = process.env.REACT_APP_API_PASSWORD;

// const BackendUname =process.env.REACT_APP_BACKEND_API_USERNAME;
// const BackendPwd =process.env.REACT_APP_BACKEND_API_PASSWORD;

// const Nav = () => {
//   const [isDropdownOpen, setIsDropdownOpen] = useState(false);
//   const [anchorElUser, setAnchorElUser] = React.useState(null);
//   const dropdownRef = useRef(null);
//   const navigate = useNavigate();

//   const jwttoken = sessionStorage.getItem('authToken');
//   const { userName, userType } = verifyToken(jwttoken);

//   const token = Buffer.from(`${BackendUname}:${BackendPwd}`).toString('base64');

//   const isAdmin = userType === 'ADMIN' || userType === 'SUPER';

//   const handleOpenUserMenu = (event) => {
//     setAnchorElUser(event.currentTarget);
//   };

//   const toggleDropdown = () => {
//     setIsDropdownOpen((prevState) => !prevState);
//   };

//   const handleCloseUserMenu = (setting) => async (event) => {
//     if (event && event.type === 'clickaway') {
//       return;
//     }

//     if (setting === 'Logout') {
//       console.log(token)
//       await axios.patch(
//         `${REACT_EXPRESS}/logout/${userName}`,
//         null,
//         {
//           headers: {
//             Authorization: `Basic ${token}`,
//           },
//         }
//       );
//       localStorage.removeItem('authToken');
//       sessionStorage.removeItem('authToken');
//       sessionStorage.removeItem('reloaded');
//       navigate('/signin');
//     } else if (setting === 'Profile') {
//       navigate('/ProfilePage');
//     } else if (setting === 'Change Password') {
//       navigate('/changePassword');
//     } else {
//       //Console.log('Invalid setting');
//     }

//     setAnchorElUser(null);
//   };

//   const handleClickOutside = (event) => {
//     if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//       setIsDropdownOpen(false);
//     }
//   };

//   useEffect(() => {
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   return (
//     <section className="nav">
//       <nav className="navbar navbar-expand-lg navbar-light w-100">
//         <div className="container-fluid">
//           <button
//             className="navbar-toggler"
//             type="button"
//             data-bs-toggle="collapse"
//             data-bs-target="#navbarNavDropdown"
//             aria-controls="navbarNavDropdown"
//             aria-expanded="false"
//             aria-label="Toggle navigation"
//           >
//             <span className="navbar-toggler-icon me-8"></span>
//           </button>
//           <Avatar src={Logo} />
//           <Link className="navbar-brand nav-brand1 ms-2" to="/home">
//             JMS CLIENT PORTAL
//           </Link>

//           <div className="collapse navbar-collapse" id="navbarNavDropdown">
//             <ul className="navbar-nav">
//               <li className="nav-item dropdown" ref={dropdownRef}>
//                 <button
//                   className="nav-link dropdown-toggle text-light btn doc-dropdown"
//                   onClick={toggleDropdown}
//                   aria-expanded={isDropdownOpen}
//                 >
//                   Documents
//                 </button>
//                 {isDropdownOpen && (
//                   <ul
//                     className="dropdown-menu show"
//                     style={{ marginTop: "10px", borderRadius: "2px" }}
//                   >
//                     <li>
//                       <Link
//                         className="dropdown-item"
//                         to="/Draftorders"
//                         style={{
//                           borderRadius: "4px",
//                           transition: "background-color 0.2s ease",
//                           ":hover": {
//                             backgroundColor: "#97999c"
//                           }
//                         }}
//                       >
//                         Request For Quotation
//                       </Link>
//                     </li>
//                     <li>
//                       <Link
//                         className="dropdown-item"
//                         to="/PurchaseQuotes"
//                         style={{
//                           borderRadius: "4px",
//                           transition: "background-color 0.2s ease",
//                           ":hover": {
//                             backgroundColor: "#e9ecef"
//                           }
//                         }}
//                       >
//                         Purchase Quotes
//                       </Link>
//                     </li>
//                     <li>
//                       <Link className="dropdown-item" to="/PurchaseOrders"
//                         style={{
//                           borderRadius: "4px",
//                           transition: "background-color 0.2s ease",
//                           ":hover": {
//                             backgroundColor: "#e9ecef"
//                           }
//                         }}>
//                         Purchase Orders
//                       </Link>
//                     </li>
//                     <li>
//                       <Link className="dropdown-item" to="/PostedPurchaseInvoices"
//                         style={{
//                           borderRadius: "4px",
//                           transition: "background-color 0.2s ease",
//                           ":hover": {
//                             backgroundColor: "#e9ecef"
//                           }
//                         }}>
//                         Order History
//                       </Link>
//                     </li>
//                     <li>
//                       <Link className="dropdown-item" to="/Receipts"
//                         style={{
//                           borderRadius: "4px",
//                           transition: "background-color 0.2s ease",
//                           ":hover": {
//                             backgroundColor: "#e9ecef"
//                           }
//                         }}>
//                         Shipments
//                       </Link>
//                     </li>
//                     <li>
//                       <Link className="dropdown-item" to="/PurchaseCreditMemos"
//                         style={{
//                           borderRadius: "4px",
//                           transition: "background-color 0.2s ease",
//                           ":hover": {
//                             backgroundColor: "#e9ecef"
//                           }
//                         }}>
//                         Purchase Credit Memos
//                       </Link>
//                     </li>
//                   </ul>
//                 )}
//               </li>
//               <li className="nav-item">
//                 <Link className="nav-link text-light" to="/Items">
//                   Items
//                 </Link>
//               </li>
//               <li className="nav-item">
//                 <Link className="nav-link text-light" to="/Payments">
//                   Payments
//                 </Link>
//               </li>
//               <li className="nav-item">
//                 <Link className="nav-link text-light" to="/infor">
//                   Information
//                 </Link>
//               </li>
//               <li className="nav-item">
//                 <Link className="nav-link text-light" to="/faq">
//                   Inquire
//                 </Link>
//               </li>
//               {isAdmin && (
//                 <li className="nav-item">
//                   <Link className="nav-link text-light" to="/faqPage">
//                     Questions
//                   </Link>
//                 </li>
//               )}
//             </ul>
//           </div>
//           {isAdmin && (<Link className="me-3 text-light" to="/UserManagement">
//             <FaUsers fontSize={28} /> <span className="user-mgm">USER MANAGEMENT</span>
//           </Link>)}
//           <Box sx={{ flexGrow: 0 }}>
//             <Tooltip title="Open user settings">
//               <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
//                 <FaUserCircle style={{ color: "white" }} />
//               </IconButton>
//             </Tooltip>
//             <Menu
//               sx={{
//                 mt: '40px',
//                 '& .MuiPaper-root': {
//                   borderRadius: '1px',
//                 },
//                 '& .MuiMenuItem-root': {
//                   '&:hover': {
//                     backgroundColor: '#f5f5f5',
//                   },
//                 },
//               }}
//               id="menu-appbar"
//               anchorEl={anchorElUser}
//               anchorOrigin={{
//                 vertical: 'top',
//                 horizontal: 'right',
//               }}
//               keepMounted
//               transformOrigin={{
//                 vertical: 'top',
//                 horizontal: 'right',
//               }}
//               open={Boolean(anchorElUser)}
//               onClose={handleCloseUserMenu()}
//             >
//               {settings.map((setting) => (
//                 <MenuItem key={setting} onClick={handleCloseUserMenu(setting)}>
//                   <Typography sx={{ textAlign: 'center' }}>{setting}</Typography>
//                 </MenuItem>
//               ))}
//             </Menu>
//           </Box>
//         </div>
//       </nav>
//     </section>
//   );
// };

// export default Nav;
import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaCog } from "react-icons/fa";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import { Avatar } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import { FaUserCircle } from "react-icons/fa";
import verifyToken, { isPortalAdmin } from "../HelperFx/verifyJwt.js";
import Logo from "../images/logo/logo.png";
import { Buffer } from "buffer";
import axios from "axios";

const settings = ["Profile", "Change Password", "Logout"];
const REACT_EXPRESS = process.env.REACT_APP_EXPRESS_SERVER;

const BackendUname = process.env.REACT_APP_BACKEND_API_USERNAME;
const BackendPwd = process.env.REACT_APP_BACKEND_API_PASSWORD;

const Nav = () => {
  const [isDocumentsOpen, setIsDocumentsOpen] = useState(false);
  const [isBmeOpen, setIsBmeOpen] = useState(false);

  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const documentsRef = useRef(null);
  const bmeRef = useRef(null);

  const navigate = useNavigate();
  const jwttoken = sessionStorage.getItem("authToken");
  const decoded = verifyToken(jwttoken) || {};
  const { userName } = decoded;
  const token = Buffer.from(`${BackendUname}:${BackendPwd}`).toString("base64");
  const isAdmin = isPortalAdmin(decoded, sessionStorage.getItem("isAdmin"));

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const toggleDocuments = () => {
    setIsDocumentsOpen((prev) => !prev);
    setIsBmeOpen(false); // Close other dropdown
  };

  const toggleBme = () => {
    setIsBmeOpen((prev) => !prev);
    setIsDocumentsOpen(false); // Close other dropdown
  };

  const handleCloseUserMenu = (setting) => async (event) => {
    if (event && event.type === "clickaway") return;

    if (setting === "Logout") {
      try {
        if (userName) {
          await axios.patch(
            `${REACT_EXPRESS}/logout/${encodeURIComponent(userName)}`,
            null,
            {
              headers: { Authorization: `Basic ${token}` },
              validateStatus: () => true,
            },
          );
        }
      } catch (_error) {
        // Session is still cleared locally even if the API is unavailable.
      } finally {
        localStorage.removeItem("authToken");
        sessionStorage.removeItem("authToken");
        sessionStorage.removeItem("reloaded");
        sessionStorage.removeItem("isAdmin");
        window.dispatchEvent(new Event("tokenUpdated"));
        navigate("/signin");
      }
      return;
    } else if (setting === "Profile") {
      navigate("/ProfilePage");
    } else if (setting === "Change Password") {
      navigate("/changePassword");
    }

    setAnchorElUser(null);
  };

  // Close dropdowns when clicking outside
  const handleClickOutside = (event) => {
    if (documentsRef.current && !documentsRef.current.contains(event.target)) {
      setIsDocumentsOpen(false);
    }
    if (bmeRef.current && !bmeRef.current.contains(event.target)) {
      setIsBmeOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Close dropdowns when navbar collapses (mobile)
  const closeAllDropdowns = () => {
    setIsDocumentsOpen(false);
    setIsBmeOpen(false);
  };

  return (
    <section className="nav">
      <nav className="navbar navbar-expand-lg navbar-none bg-none w-100">
        <div className="container-fluid">
          {/* Toggler */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNavDropdown"
            aria-controls="navbarNavDropdown"
            aria-expanded="false"
            aria-label="Toggle navigation"
            onClick={closeAllDropdowns}
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Logo + Brand */}
          <Avatar src={Logo} sx={{ width: 40, height: 40 }} className="ms-2" />
          <Link className="navbar-brand nav-brand1 ms-2" to="/home">
            JMS CLIENT PORTAL
          </Link>

          {/* Main Navigation */}
          <div className="collapse navbar-collapse" id="navbarNavDropdown">
            <ul className="navbar-nav me-auto">
              {/* Documents Dropdown */}
              <li className="nav-item dropdown" ref={documentsRef}>
                <button
                  className="nav-link dropdown-toggle text-light btn doc-dropdown"
                  onClick={toggleDocuments}
                  aria-expanded={isDocumentsOpen}
                >
                  Documents
                </button>
                {isDocumentsOpen && (
                  <ul
                    className="dropdown-menu show"
                    style={{ marginTop: "8px" }}
                  >
                    <li>
                      <Link className="dropdown-item" to="/Draftorders">
                        Request For Quotation
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/PurchaseQuotes">
                        Purchase Quotes
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/PurchaseOrders">
                        Purchase Orders
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/PostedPurchaseInvoices"
                      >
                        Order History
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/Receipts">
                        Shipments
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/PurchaseCreditMemos">
                        Purchase Credit Memos
                      </Link>
                    </li>
                  </ul>
                )}
              </li>

              {/* BME Dropdown - NEW */}
              <li className="nav-item dropdown" ref={bmeRef}>
                <button
                  className="nav-link dropdown-toggle text-light btn doc-dropdown"
                  onClick={toggleBme}
                  aria-expanded={isBmeOpen}
                >
                  BME
                </button>
                {isBmeOpen && (
                  <ul
                    className="dropdown-menu show"
                    style={{ marginTop: "8px" }}
                  >
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/CustomerInventoryList"
                      >
                        Customer Inventory
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/WorkOrders">
                        Field Work Orders
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/ServiceOrders">
                        Service Orders
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/DisposalRequests">
                        Disposal Requests
                      </Link>
                    </li>
                  </ul>
                )}
              </li>

              {/* Regular Links */}
              <li className="nav-item">
                <Link className="nav-link text-light" to="/Items">
                  Items
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link text-light" to="/Payments">
                  Payments
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link text-light" to="/infor">
                  Information
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link text-light" to="/faq">
                  Inquire
                </Link>
              </li>
              {isAdmin && (
                <li className="nav-item">
                  <Link className="nav-link text-light" to="/faqPage">
                    Questions
                  </Link>
                </li>
              )}
            </ul>
          </div>

          {/* Right Side */}
          {isAdmin && (
            <Tooltip title="Settings">
              <Link
                className="me-3 text-light d-flex align-items-center"
                to="/UserManagement"
                aria-label="Settings"
              >
                <FaCog fontSize={24} />
              </Link>
            </Tooltip>
          )}

          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Open user settings">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <FaUserCircle style={{ color: "white", fontSize: "28px" }} />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{
                mt: "45px",
                "& .MuiPaper-root": { borderRadius: "4px" },
              }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
              keepMounted
              transformOrigin={{ vertical: "top", horizontal: "right" }}
              open={Boolean(anchorElUser)}
              onClose={() => setAnchorElUser(null)}
            >
              {settings.map((setting) => (
                <MenuItem key={setting} onClick={handleCloseUserMenu(setting)}>
                  <Typography textAlign="center">{setting}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </div>
      </nav>
    </section>
  );
};

export default Nav;
